import { render, staticRenderFns } from "./ModalSize.vue?vue&type=template&id=35867115"
import script from "./ModalSize.vue?vue&type=script&lang=js"
export * from "./ModalSize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports